import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CalendarioImportarComponent } from './calendario-importar/calendario-importar.component';
import { HorarioHomeComponent } from './horario-home/horario-home.component';
import { HorarioMateriasListaComponent } from './horario-materias-lista/horario-materias-lista.component';


const routes: Routes = [
{
  path: 'importar',
  component: CalendarioImportarComponent,
},
{
  path: 'listado',
  component: HorarioHomeComponent,
},
{
  path: 'fecha/:fecha/escuela/:escuela',
  component: HorarioMateriasListaComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CalendarioRoutingModule { }
